import { InjectionToken } from '@angular/core';
import { IFlattenedService } from '../services/flattened-meds/FlattenedMedService';

export const FLATTENED_MED_SERVICE = new InjectionToken<IFlattenedService>('FLATTENED_MED_SERVICE');
